import React from 'react';

import Box from '@material-ui/core/Box';
// import {makeStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

// const useStyles = makeStyles((theme) => ({}));

const Thanks = () => {
  // const classes = useStyles();

  return (
    <Box py={10}>
      <Typography variant="h3" align="center">
        Gracias viejo
      </Typography>
    </Box>
  );
};

export default Thanks;
